import * as Yup from 'yup';
import DomPurify from 'dompurify';
import { TemplateFormRadioGroupFieldMetaProps } from '../interfaces/template-form-radio-group-field-meta';
import { TemplateFormRadioWrapper } from '../TemplateFormRadioWrapper';
import { TemplateFormRadioGroupField } from '../TemplateFormRadioGroupField';
import { TemplateFormHelperText } from '../../TemplateFormHelperText';
import { TemplateFormComponentMeta } from '../../../interfaces/template-form-component-meta';

export const RadioGroupFieldMeta: TemplateFormComponentMeta<TemplateFormRadioGroupFieldMetaProps> =
  {
    component: TemplateFormRadioGroupField,
    MetadataFactory: (field, disableEdit) => ({
      name: `${field.name}-group`,
      className: 'grid-column-space-20',
      label: DomPurify.sanitize(field.display_name ?? ''),
      defaultValue: field.default_value ? (field.default_value as string) : '',
      currentValue: field.default_value ? (field.default_value as string) : '',
      children: TemplateFormRadioWrapper({
        options: Array.isArray(field.metadata?.options)
          ? field.metadata!.options.map(
              (option: { label: string; value: string; sub_title?: string }) => ({
                dataId: option.value,
                label: option.label,
                children: option.sub_title
                  ? TemplateFormHelperText({
                      helperText: { text: option.sub_title },
                      fieldName: field.name
                    })
                  : null,
                radioProps: {
                  label: option.label,
                  disabled: disableEdit || !!field.disabled,
                  value: option.value
                }
              })
            )
          : [],
        fieldName: field.name
      })
    }),
    ValidationSchemaFactory: () => Yup.object().shape({})
  };
